import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import homeSummaryApi from 'api/homeSummary';
import { useAuth } from 'components/context/AuthContext';

export default function useHomeSummary() {
  const { auth } = useAuth();
  const activeBrandId = auth?.user?.active_brand_id;
  const isGoogleConnected = Boolean(auth?.user?.google_ads_connected && auth?.user?.google_ads_customer_id);
  const isMetaConnected = Boolean(auth?.user?.meta_connected && auth?.user?.meta_ad_account_id);

  const platform = useMemo(() => {
    if (isGoogleConnected && !isMetaConnected) return 'google';
    if (!isGoogleConnected && isMetaConnected) return 'meta';
    return null;
  }, [isGoogleConnected, isMetaConnected]);

  const query = useQuery({
    queryKey: ['home', 'summary', String(activeBrandId || ''), platform || 'all'],
    enabled: Boolean(activeBrandId),
    queryFn: async () => {
      const res = await homeSummaryApi.getHomeSummary(activeBrandId, { platform: platform || undefined });
      return res?.data ?? res;
    },
    staleTime: 2 * 60 * 1000,
    gcTime: 20 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 2,
  });

  const errorMessage =
    query.error?.response?.data?.error ||
    query.error?.response?.data?.message ||
    query.error?.message ||
    (query.isError ? 'No se pudo cargar el resumen. Intentá de nuevo.' : null);

  return {
    loading: query.isPending,
    error: errorMessage,
    data: query.data ?? null,
    refetch: query.refetch,
    platform,
  };
}

